import {BehaviorSubject} from "rxjs";
import {EventEmitter} from "@angular/core";
import {HttpParams} from "@angular/common/http";
import {IFilter} from "../../services/IFilter";

export class TicketWorklogFilter implements IFilter {

  anyChange:EventEmitter<any> = new EventEmitter<any>();

  constructor() {
    this.clear();
  }

  ticketIdChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get ticketId():any {
    return this.ticketIdChange.value;
  }
  set ticketId(id:any) {

    this.ticketIdChange.next(id);
    this.emitChange("ticketId", id);
  }

  datetimeChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get datetime():any {
    return this.datetimeChange.value;
  }
  set datetime(datetime:any) {
    this.datetimeChange.next(datetime);
    this.emitChange("datetime", datetime);
  }

  feedbackChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get feedback():any {
    return this.feedbackChange.value;
  }
  set feedback(feedback:any) {
    this.feedbackChange.next(feedback);
    this.emitChange("feedback", feedback);
  }

  userIdChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get userId():any {
    return this.userIdChange.value;
  }
  set userId(userId:any) {
    this.userIdChange.next(userId);
    this.emitChange("userId", userId);
  }

  emitChange(prop:string, value:any):void {
    this.anyChange.emit({"prop": prop, "value": value});
  }

  getParams():HttpParams {
    let params:HttpParams = new HttpParams();

    if (this.ticketId && this.ticketId !== '') {
      params = params.set("ticketId", this.ticketId);
    }
    if (this.datetime && this.datetime !== '') {
      params = params.set("datetime", this.datetime);
    }
    if (this.feedback && this.feedback !== '') {
      params = params.set("feedback", this.feedback);
    }
    if (this.userId && this.userId !== '') {
      params = params.set("userId", this.userId);
    }

    return params;
  }

  setFilters(props: any): void {
    this.ticketIdChange.next(props.ticketId || undefined);
    this.datetimeChange.next(props.datetime || undefined);
    this.feedbackChange.next(props.feedback || undefined);
    this.userIdChange.next(props.userId || undefined);
  }

  toObj() {
    let obj:any = {};
    obj.ticketId = this.ticketId;
    obj.datetime = this.datetime;
    obj.feedback = this.feedback;
    obj.userId = this.userId;
    return obj;
  }


  public clear():void {
    this.ticketId = undefined;
    this.datetime = undefined;
    this.feedback = undefined;
    this.userId = undefined;
  }
}
